/**
 * Global core entry point (critical path JS).
 *
 * - Initializes global utilities, consent management, accessibility, and first-paint UI behaviors.
 * - Loaded at page start for blocking runtime execution.
 * - Shared across both legacy and revamp storefronts.
 * 
 *  * This script is loaded with `defer`, meaning it runs only *after* the HTML is fully parsed.
 * Therefore, no need to wrap logic in `DOMContentLoaded` — the DOM is guaranteed to be ready.
 */

window.jQuery = window.$ = require('jquery');
var processInclude = require('app_custom_merge_mufe/util');
$(document).ready(function () {
    processInclude(require('./components/promoBanner'));
    processInclude(require('app_custom_mufe/components/animationBanner'));
    processInclude(require('app_custom_merge_mufe/components/cookie'));
    processInclude(require('app_custom_merge_mufe/components/consentTracking'));
    processInclude(require('./utilities/breakpoints'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/scrollManager'));
    processInclude(require('./components/footer'));
    processInclude(require('app_custom_merge_mufe/triggerify'));
    processInclude(require('app_custom_merge_mufe/countries'));
    // TODO: countrySelector is required from two sources — consider merging or renaming to avoid confusion.
    processInclude(require('app_custom_merge_mufe/countrySelector'));
    processInclude(require('app_custom_mufe/components/countrySelector'));
    processInclude(require('app_custom_merge_mufe/components/clientSideValidation'));
    processInclude(require('app_custom_merge_mufe/components/accessibilityHelpers'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./utilities/screen'));
    processInclude(require('./utilities/lazyload'));
});

require('app_custom_merge_mufe/thirdParty/bootstrap');
require('app_custom_merge_mufe/components/spinner');
// TODO - Delete slick & owl calls
require('app_custom_merge_mufe/thirdParty/slick');
require('app_custom_mufe/lib/slick-slider-config');
require('app_custom_merge_mufe/thirdParty/owl');
